module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"product_option":"商品選項","positive":"滿意","neutral":"一般","negative":"有待改進","expand_review":"查看更多","collapse_review":"顯示較少"}}')
  delete Component.options._Ctor
}
